import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { setMenuSelected } from '@redux/actions/menuAction';
import Clearfix from 'components/elements/clearfix';
import { FIELDS } from 'containers/FacilityHazarWasteReportContainer/constants';
import PropTypes from 'prop-types';
import Message from 'rc-message';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import AttachmentForm from './AttachmentForm';
import AttachmentList from './AttachmentList';
import Permissions from 'react-redux-permissions';
import { COLOR } from 'config';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

class Attachment extends React.Component {
  static propTypes = {
    getListFunc: PropTypes.func.isRequired,
    deleteOne: PropTypes.func.isRequired,
    createOne: PropTypes.func.isRequired,
    facility: PropTypes.object.isRequired,
    moduleName: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      isEdit: false,
    };
  }

  showEditForm = () => {
    this.setState({
      isEdit: true,
    });
  };

  hideEditForm = () => {
    this.setState({
      isEdit: false,
    });
  };

  renderHeader() {
    console.log(this.props.moduleName, '--this.props.moduleName--');
    return (
      <div>
        <h3
          style={{
            color: COLOR.SUCCESS,
          }}
          className='bp3-heading'
        >
          File đính kèm
        </h3>
        {!this.props.hideButtonAction && (
          <Header>
            <Permissions allowed={[`${this.props.moduleName}.write`]}>
              <div style={{ display: 'inline-flex' }}>
                {!this.state.isEdit && (
                  <Icon
                    style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                    icon={IconNames.ADD}
                    iconSize={Icon.SIZE_LARGE}
                    intent={Intent.SUCCESS}
                    onClick={this.showEditForm}
                  />
                )}
                {this.state.isEdit && (
                  <div style={{ display: 'inline-flex' }}>
                    <Icon
                      style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                      icon={IconNames.SAVED}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.PRIMARY}
                      onClick={this.handelSubmit}
                    />
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.DISABLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.hideEditForm}
                    />
                  </div>
                )}
              </div>
            </Permissions>
          </Header>
        )}
      </div>
    );
  }

  getFormValue = () => {
    let formValues;
    if (this.AttactmentFormComp && this.AttactmentFormComp.getForm()) {
      const form = this.AttactmentFormComp.getForm();
      form.validateFields((error, value) => {
        if (value.file) {
          const { file } = value.file;
          value.FileNameDisplay = file.originalname;
          value.FileNameServer = file.filename;
          value.NumBytes = file.size;
        }
        formValues = value;
        formValues.attachmentType = _.get(
          value,
          [FIELDS.attachmentType, 'value'],
          ''
        );
      });
    }
    return formValues;
  };

  handelSubmit = async () => {
    try {
      const values = this.getFormValue() || {};
      if (!values.Title || !values.file) return;

      const res = await this.props.createOne(_.pickBy(values, _.identity));
      if (res.success) {
        Message.success({ content: 'Tạo Thành Công' });
        this.hideEditForm();
        if (this.AttactmentListComp && this.AttactmentListComp.fetData)
          this.AttactmentListComp.fetData();
      }
      if (res.error) Message.error({ content: res.message });
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <div>
        {this.renderHeader()}
        {this.state.isEdit && (
          <AttachmentForm
            {...this.props}
            ref={(AttactmentFormComp) => {
              this.AttactmentFormComp = AttactmentFormComp;
            }}
          />
        )}
        <AttachmentList
          {...this.props}
          onRef={(AttactmentListComp) => {
            this.AttactmentListComp = AttactmentListComp;
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  menuStore: state.menu,
});

const mapDispatchToProps = {
  setMenuSelected,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Attachment)
);



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportView/Attachment/index.js